import React from "react"
import badge from "badges/master-of-numbers.svg"
import { BadgeImage } from "backpack/badges/styled"

const MasterOfNumbers = props => <BadgeImage src={badge} {...props} />

export default MasterOfNumbers
